import { render, staticRenderFns } from "./services_page2.vue?vue&type=template&id=301f5cc1&scoped=true&"
import script from "./services_page2.vue?vue&type=script&lang=js&"
export * from "./services_page2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301f5cc1",
  null
  
)

export default component.exports